import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';

const QRPage: React.FC = () => {
  const { t } = useTranslation();
  const [storeUrl, setStoreUrl] = useState('https://notely.se');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
      setStoreUrl('https://play.google.com/store/apps/details?id=com.cstate.notelyapp');
    } else if (/iphone|ipad|ipod|macintosh/.test(userAgent)) {
      setStoreUrl('https://apps.apple.com/se/app/notely-ai/id6740462619?l=en-GB&platform=iphone');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="bg-gray-800 p-4 sm:p-7 rounded-lg shadow-xl w-full max-w-[90vw] sm:max-w-md text-center">
        <div className="w-full">
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6">{t('qr.title')}</h1>
        </div>
        <div className="bg-white p-2 sm:p-4 rounded-lg inline-block mb-4 sm:mb-6">
          <div className="w-[min(80vw,300px)] h-[min(80vw,300px)]">
            <QRCodeSVG
              value={storeUrl}
              size={300}
              level="H"
              includeMargin={true}
              className="w-full h-full"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
        <p className="text-gray-400 mb-4">
          {t('qr.scanInstructions')}
        </p>
        <a
          href={storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:text-primary/80 transition-colors"
        >
          {t('qr.clickDownload')}
        </a>
      </div>
    </div>
  );
};

export default QRPage; 